import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { Button } from '@depop/web-ui-kit/Button';
import { LazyLoadImage } from '@depop/web-ui-kit/LazyLoadImage';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { useProductById } from '@/modules/product/hooks/useProductById';
import { type Receipt } from '@/modules/receipts/types';

type Props = Receipt.Receipt;

export function RepopTile({
  paymentDetails,
  lineItems,
  purchaseId,
  items,
}: Props) {
  const t = useTranslations('shop');
  const purchaseItemId = lineItems?.[0]?.id;
  const productIds = items?.map((item) => item.productId) || [];
  const { data: productByIdResponse } = useProductById({
    productId: productIds[0].toString(),
  });

  function getCategoryBrandText() {
    const brandName = productByIdResponse?.data.brand_name;
    const groupName = productByIdResponse?.data.attributes?.group_name;

    if (groupName && brandName) {
      return `${groupName}, ${brandName}`;
    }
    return groupName || brandName || '';
  }

  return (
    <div className={styles.container}>
      <LazyLoadImage src={items?.[0]?.pictureUrl} alt="" />
      <div className={styles.textWrapper}>
        {productByIdResponse?.data && (
          <Body variant="sm-regular" className={styles.categoryBrandText}>
            {getCategoryBrandText()}
          </Body>
        )}
        <Body
          variant="sm-bold"
          className={styles.purchasedText}
          type="caption2"
        >
          {`${t('Purchased')}: ${paymentDetails.currency}${paymentDetails.buyerPaidAmount}`}
        </Body>
      </div>
      <ExtendedLink
        href={`/products/create?pid=${purchaseId}&piid=${purchaseItemId}&cta=ShopEmptyState.Repop`}
      >
        <Button as="span" size="md">
          Repop
        </Button>
      </ExtendedLink>
    </div>
  );
}
